<template>
    <v-dialog persistent v-model="dialog" max-width="95%">
      <v-container fluid v-if="pollActivity">
        <v-card>
          <v-card-title class="d-flex align-center justify-space-between primary white--text">
            <div class="d-flex justify-center align-center">
              Diagnóstico Habilidades Digitales {{ pollActivity.id }}
            </div>
            <div class="d-flex align-center">
              <v-chip :color="getStatusClass(pollActivity)" class="mr-2">
                {{ new Date(`${pollActivity.limit}T23:59:00-03:00`) >= new Date() ? 'Activo' : 'Terminado' }}
              </v-chip>
              <v-btn class="mt-2 ml-3" color="red" @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
  
          <v-row class="ma-4">
            <v-col cols="12" md="6" class="pr-4 outlined">
              <div class="d-flex justify-space-between mt-1 mx-4">
                <div class="statistic-card">
                  <h2>{{ formatTime(filteredTimeSpentAverage) }}</h2>
                  <p>Tiempo promedio</p>
                </div>
                <div class="statistic-card">
                  <h2>{{ this.completionStatus?.completed.count }}</h2>
                  <p>Completaron</p>
                </div>
                <div class="statistic-card">
                  <h2>{{ this.completionStatus?.remaining.count }}</h2>
                  <p>Pendientes</p>
                </div>
              </div>
              <v-row class="my-4 mx-4">
                <v-col cols="12" md="6" class="py-0">
                  <v-select
                    v-model="filters.gender"
                    :items="[
                      { text: 'Todos', value: null },
                      { text: 'Mujer', value: '1' },
                      { text: 'Hombre', value: '2' }
                    ]"
                    label="Filtrar por género"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-select
                    v-model="filters.equipment"
                    :items="[
                      { text: 'Computadora de escritorio', value: '1' },
                      { text: 'Laptop', value: '2' },
                      { text: 'Tablet', value: '3' },
                      { text: 'Celular', value: '4' }
                    ]"
                    label="Filtrar por equipos"
                    multiple
                    chips
                    outlined
                    dense
                    hide-details
                    clearable
                    deletable-chips
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip 
                        v-if="index < 2" 
                        small
                        close
                        @click:close="removeEquipment(item.value)"
                      >
                        {{ item.text }}
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ filters.equipment.length - 2 }} otros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
  
              <v-tabs v-model="sectionTab" grow>
                <v-tab v-for="(section, index) in sectionNames" :key="index">
                  {{ section }}
                </v-tab>
              </v-tabs>
  
              <v-tabs-items touchless v-model="sectionTab">
                <!-- Sección 1: Datos Generales -->
                <v-tab-item :key="0">
                  <v-card class="mt-4">
                    <div class="scrollable-content">
                      <v-card v-for="(question, qIndex) in getQuestionsForSection(0)" :key="qIndex" class="mb-4">
                        <v-card-title style="background-color: rgba(63, 81, 181, 0.8);" class="white--text">
                          Pregunta {{ qIndex + 1 }}: {{ question.text }}
                          <v-chip class="caption d-flex justify-end align-center ma-2" small>
                            Tipo: {{ questionTypeMap[question.type] }}
                          </v-chip>
                        </v-card-title>
                        
                        <v-card-text>
                          <!-- Renderizado para Selección Única (Sexo) -->
                          <template v-if="question.type === 'single_choice'">
                            <v-divider class="mb-4"></v-divider>
                            <div class="d-flex flex-column">
                              <div v-for="(option, j) in question.options" :key="j">
                                <div class="d-flex justify-space-between">
                                  <div class="d-flex statistic-card">
                                    {{ j + 1 }})
                                    <h4 class="ml-2 text-left">
                                      {{ option.text }}
                                    </h4>
                                  </div>
                                  <div class="statistic-card justify-center align-content-center">
                                    <v-btn @click="openModal('alternative', question.id, option.id)">
                                      <h4 class="text-left">
                                        {{ getAnswerCount(question.id, option.id) }} Respuestas
                                      </h4>
                                    </v-btn>
                                  </div>
                                  <div class="statistic-card justify-center align-content-center">
                                    <v-progress-linear
                                      :value="getAnswerPercentage(question.id, option.id)"
                                      color="primary"
                                      height="20"
                                      rounded
                                      striped
                                    >
                                      {{ getAnswerPercentage(question.id, option.id) }}%
                                    </v-progress-linear>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
  
                          <!-- Renderizado para Selección Múltiple (Equipos) -->
                          <template v-if="question.type === 'multiple_choice'">
                            <v-divider class="mb-4"></v-divider>
                            <div class="d-flex flex-column">
                              <div v-for="(option, j) in question.options" :key="j">
                                <div class="d-flex justify-space-between">
                                  <div class="d-flex statistic-card">
                                    {{ j + 1 }})
                                    <h4 class="ml-2 text-left">
                                      {{ option.text }}
                                    </h4>
                                  </div>
                                  <div class="statistic-card justify-center align-content-center">
                                    <v-btn @click="openModal('alternative', question.id, option.id)">
                                      <h4 class="text-left">
                                        {{ getMultipleChoiceCount(question.id, option.id) }} Respuestas
                                      </h4>
                                    </v-btn>
                                  </div>
                                  <div class="statistic-card justify-center align-content-center">
                                    <v-progress-linear
                                      :value="getMultipleChoicePercentage(question.id, option.id)"
                                      color="primary"
                                      height="20"
                                      rounded
                                      striped
                                    >
                                      {{ getMultipleChoicePercentage(question.id, option.id) }}%
                                    </v-progress-linear>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-tab-item>
  
                <!-- Sección 2: Habilidades Digitales -->
                <v-tab-item :key="1">
                  <v-card class="mt-4">
                    <div class="scrollable-content">
                      <v-card v-for="(question, qIndex) in getQuestionsForSection(1)" :key="qIndex" class="mb-4">
                        <v-card-title style="background-color: rgba(63, 81, 181, 0.8);" class="white--text">
                          Pregunta {{ qIndex + 1 }}: {{ question.text }}
                          <v-chip class="caption d-flex justify-end align-center ma-2" small>
                            Tipo: {{ questionTypeMap[question.type] }}
                          </v-chip>
                        </v-card-title>
                        
                        <v-card-text>
                          <!-- Renderizado para preguntas de habilidades digitales (single_choice todas) -->
                          <v-divider class="mb-4"></v-divider>
                          <div class="d-flex flex-column">
                            <div v-for="(option, j) in question.options" :key="j">
                              <div class="d-flex justify-space-between">
                                <div class="d-flex statistic-card">
                                  {{ j + 1 }})
                                  <h4 class="ml-2 text-left">
                                    {{ option.text }}
                                  </h4>
                                </div>
                                <div class="statistic-card justify-center align-content-center">
                                  <v-btn @click="openModal('alternative', question.id, option.id)">
                                    <h4 class="text-left">
                                      {{ getAnswerCount(question.id, option.id) }} Respuestas
                                    </h4>
                                  </v-btn>
                                </div>
                                <div class="statistic-card justify-center align-content-center">
                                  <v-progress-linear
                                    :value="getAnswerPercentage(question.id, option.id)"
                                    color="primary"
                                    height="20"
                                    rounded
                                    striped
                                  >
                                    {{ getAnswerPercentage(question.id, option.id) }}%
                                  </v-progress-linear>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
  
            <v-col cols="12" md="6" class="outlined">
              <div class="d-flex justify-space-between align-center">
                <v-tabs v-model="resultsTab" grow>
                  <v-tab>Resultados</v-tab>
                  <v-tab>Finalizado</v-tab>
                  <div class="d-flex justify-center align-center">
                    <EditPollActivity :pollActivity="pollActivity" @poll-activity-updated="loadData" />
                  </div>
                </v-tabs>
                <info-button
                  class="mx-6"
                  title="Información sobre el dashboard de habilidades digitales"
                  message="
                  <ul>
                    <li><strong>Estructura general:</strong> El dashboard se divide en dos secciones principales. A la izquierda se muestran las preguntas del diagnóstico con sus estadísticas y a la derecha los resultados detallados.</li>
                    
                    <li><strong>Sección izquierda:</strong>
                      <ul>
                        <li>Tarjetas con métricas clave: tiempo promedio, respuestas recibidas, completados y pendientes</li>
                        <li>Datos Generales: Estadísticas sobre sexo y dispositivos utilizados</li>
                        <li>Habilidades Digitales: Estadísticas sobre cada habilidad evaluada</li>
                      </ul>
                    </li>
  
                    <li><strong>Sección derecha:</strong>
                      <ul>
                        <li>Pestaña de Resultados: Tabla con todas las respuestas de estudiantes</li>
                        <li>Pestaña de Gráficos: Visualización de dona con progreso de completado</li>
                        <li>Botón de edición del diagnóstico</li>
                      </ul>
                    </li>
  
                    <li><strong>Funcionalidades clave:</strong>
                      <ul>
                        <li>Click en estadísticas para ver estudiantes específicos por respuesta</li>
                        <li>Edición de parámetros globales del diagnóstico</li>
                        <li>Visualización de tiempos y respuestas individuales</li>
                      </ul>
                    </li>
                  </ul>
                  "
                ></info-button>
              </div>
  
              <v-tabs-items touchless v-model="resultsTab">
                <v-tab-item>
                  <v-card class="flex-grow-1">
                    <v-card-title class="d-flex justify-space-between align-center">
                      <span>Respuesta de los estudiantes</span>
                    </v-card-title>
                    <ReplyHabilidadesDigitalesTable
                        class="pa-2"
                        v-if="filteredReplies.length > 0"
                        :replies="filteredReplies"
                        :pollActivity="pollActivity"
                        :questions="questions"
                      />
                    <v-alert v-else type="info">
                      No hay respuestas disponibles aún
                    </v-alert>
                  </v-card>
                </v-tab-item>
                
                <v-tab-item>
                  <v-card class="flex-grow-1">
                    <v-card-title class="d-flex justify-space-between align-center">
                      <span>Gráfico de Término</span>
                    </v-card-title>
                    <DoughnutChart v-show="chartDonutData" :chartData="chartDonutData" :options="chartDonutOptions" @click.native="handleDoughnutClick"></DoughnutChart>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
  
      <StudentModal 
        :isPollActivity="true" 
        :show.sync="showModal" 
        :students="modalStudents" 
        :title="modalTitle" 
      />
      
      <ModalResponses 
        :isPollActivity="true"
        :showModal.sync="showAlternativeModal"
        :questionId="selectedQuestionId"
        :alternativeId="selectedAlternativeId"
        modalType="alternative"
        :replies="replies"
      />  
    </v-dialog>
  </template>
  
  <script>
  import axios from 'axios';
  import DoughnutChart from '@/components/UI/DoughnutChart';
  import StudentModal from '@/components/UI/StudentModal';
  import EditPollActivity from '@/components/teacher/lesson/polls/forms/EditPollActivity';
  import ModalResponses from '@/components/UI/ModalResponses';
  import ReplyHabilidadesDigitalesTable from './ReplyHabilidadesDigitalesTable';
  import InfoButton from '@/components/UI/InfoButton';
  import Swal from 'sweetalert2';
  
  export default {
    props: ['pollActivity', 'dialog'],
    components: { 
      DoughnutChart, 
      ReplyHabilidadesDigitalesTable, 
      ModalResponses, 
      EditPollActivity, 
      StudentModal, 
      InfoButton 
    },
    model: {
      prop: 'dialog',
      event: 'change',
    },
    data() {
      return {
        questionTypeMap: {
          'single_choice': 'Opción única',
          'multiple_choice': 'Opción múltiple'
        },
        sectionTab: 0,
        resultsTab: 0,
        timeSpentAverage: null,
        chartDonutData: null,
        chartDonutOptions: { responsive: true },
        replies: [],
        timeSpent: [],
        modalStudents: null,
        modalTitle: "",
        showModal: false,
        selectedQuestionId: null,
        selectedAlternativeId: null,
        questions: [],
        sectionNames: ["Datos Generales", "Habilidades Digitales"],
        completionStatus: null,
        showAlternativeModal: false,
        instructions: "",
        filters: {
          gender: null, // null, '1' (mujer), o '2' (hombre)
          equipment: [] // array de equipos seleccionados
        },
        // Asumiendo que las IDs de preguntas son:
        GENDER_QUESTION_ID: '1',
        EQUIPMENT_QUESTION_ID: '2'
      };
    },
    computed: {
      filteredTimeSpentAverage() {
        const filteredTimes = this.filteredReplies.map(reply => reply.time);
        return filteredTimes.length > 0 
          ? (filteredTimes.reduce((a, b) => a + b, 0) / filteredTimes.length)
          : 0;
      },
      filteredReplies() {
        let filtered = [...this.replies];
        
        // Filtrar por género
        if (this.filters.gender) {
          filtered = filtered.filter(reply => {
            const genderAnswer = reply.answer[this.GENDER_QUESTION_ID];
            return genderAnswer && genderAnswer.answerId === this.filters.gender;
          });
        }
        
        // Filtrar por equipos
        if (this.filters.equipment.length > 0) {
          filtered = filtered.filter(reply => {
            const equipmentAnswer = reply.answer[this.EQUIPMENT_QUESTION_ID];
            if (!equipmentAnswer || !equipmentAnswer.answerId) return false;
            return this.filters.equipment.every(equip => 
              equipmentAnswer.answerId.includes(equip)
            );
          });
        }
        
        return filtered;
      },
      questionsBySection() {
        if (!this.questions) return [];
        
        // Organizar preguntas por sección
        const result = {
          0: [],
          1: []
        };
        
        // Si this.questions ya está dividido en secciones
        if (Array.isArray(this.questions[0])) {
          return this.questions;
        }
        
        // Si es un array plano, hay que organizarlo
        this.questions.forEach(question => {
          const sectionIndex = question.section === this.sectionNames[1] ? 1 : 0;
          result[sectionIndex].push(question);
        });
        
        return result;
      }
    },
    watch: {
      dialog(newValue) {
        if (newValue === true) {
          this.loadData();
        } else {
          this.resetData();
        }
      },
      pollActivity: {
        handler(newValue) {
          if (newValue) {
            // Mantener sincronizadas las preguntas
            this.description = newValue.description || null;
            this.limit = newValue.limit || null;
          }
        },
        immediate: true,
      },
    },
    methods: {
      removeEquipment(value) {
        const index = this.filters.equipment.indexOf(value);
        if (index >= 0) {
          this.filters.equipment.splice(index, 1);
        }
      },
      
      getQuestionsForSection(sectionIndex) {
        return this.questionsBySection[sectionIndex] || [];
      },
      resetData() {
        this.timeSpentAverage = null;
        this.chartDonutData = null;
        this.replies = [];
        this.timeSpent = [];
        this.questions = [];
        this.completionStatus = null;
        this.showAlternativeModal = false;
      },
      async loadData() {
        if (!this.pollActivity) return;
  
        try {
          // 1. Obtener las preguntas 
          const questionsResponse = await axios.get('/questionHabilidadesDigitales');
          this.questions = questionsResponse.data.questionsBySection;
          this.instructions = questionsResponse.data.instructions;
          
          await Promise.all([
            this.getReplies(),
            this.getActivityCompletionStatus(),
          ]);
          
        } catch (error) {
          console.error("Error loading data:", error);
          Swal.fire('Error', 'No se pudieron cargar las preguntas', 'error');
        }
      },
      formatTime(seconds) {
        if (!seconds || seconds < 0) return 'N/A';

        const totalSeconds = Math.floor(seconds); // Redondear correctamente
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return minutes > 0
        ? `${minutes}m${remainingSeconds}s`
        : `${remainingSeconds}s`;
      },
      renderCharts() {
        if (this.chartDonutData) {
          this.getDonutChart();
        }
      },
      getStatusClass(item) {
        return new Date(`${item.limit}T23:59:00-03:00`) >= new Date() ? 'blue' : 'red';
      },
      getAnswerCount(questionId, answerId) {
        return this.filteredReplies.reduce((count, reply) => {
          const answer = reply.answer[questionId];
          if (!answer) return count;
          return count + (answer.answerId === answerId ? 1 : 0);
        }, 0);
      },
      getMultipleChoiceCount(questionId, optionId) {
        return this.filteredReplies.reduce((count, reply) => {
          const answer = reply.answer[questionId];
          if (!answer || !answer.answerId) return count;
          return count + (Array.isArray(answer.answerId) && answer.answerId.includes(optionId) ? 1 : 0);
        }, 0);
      },
      getAnswerPercentage(questionId, answerId) {
        const totalReplies = this.filteredReplies.length;
        const answerReplies = this.getAnswerCount(questionId, answerId);
        return totalReplies > 0 ? ((answerReplies / totalReplies) * 100).toFixed(1) : 0;
      },
      
      getMultipleChoicePercentage(questionId, optionId) {
        const totalReplies = this.filteredReplies.length;
        const answerReplies = this.getMultipleChoiceCount(questionId, optionId);
        return totalReplies > 0 ? ((answerReplies / totalReplies) * 100).toFixed(1) : 0;
      },
      openModal(type, questionId, alternativeId) {
        this.selectedAlternativeId = alternativeId;
        this.selectedQuestionId = questionId;
        
        console.log(questionId)
      console.log(alternativeId)
      console.log(this.replies)
      
        if (type === 'alternative') {
          this.showAlternativeModal = true;
        }
      },
      handleDoughnutClick(event, array) {
        if (array.length > 0) {
          const index = array[0]._index;
          const label = this.chartDonutData.labels[index];
  
          let students = [];
          if (label === 'Terminado') {
            students = this.completionStatus.completed.students;
            this.modalTitle = 'Estudiantes que han terminado el diagnóstico';
          } else {
            students = this.completionStatus.remaining.students;
            this.modalTitle = 'Estudiantes que aún no han terminado el diagnóstico';
          }
          this.modalStudents = students.map(student => {
            const reply = this.replies.find(reply => reply.user_id === student.id);
            const time = reply ? this.formatTime(reply.time) : 0;
            const points = reply ? reply.points : 0;
            return {
              id: student.id,
              name: student.name + ' ' + student.lastName,
              time: time,
              points: points  
            };
          });
  
          this.showModal = true;
        }
      },
      getDonutChart() {
        this.chartDonutData = {
          labels: ['Terminado', 'Faltantes'],
          datasets: [
            {
              data: [this.completionStatus.completed.count, this.completionStatus.remaining.count],
              backgroundColor: ['#36A2EB', '#FF6384'],
              borderColor: ['#36A2EB', '#FF6384']
            }
          ]
        };
        this.chartDonutOptions = {
          maintainAspectRatio: false,
          onClick: this.handleDoughnutClick
        };
      },
      async getReplies() {
        await axios.get(`teacher/poll_activity/replies/${this.pollActivity.id}`)
          .then(response => {
            if (response.data.ok) {
              this.replies = response.data.replies.map(reply => ({
                ...reply,
                answer: JSON.parse(reply.answer)
              }));
  
              this.timeSpent = this.replies.map(reply => reply.time);
              this.timeSpentAverage = this.replies.length > 0 
                ? (this.timeSpent.reduce((a, b) => a + b, 0) / this.replies.length)
                : 0;
            }
          })
          .catch(error => console.error("Error fetching replies:", error));
      },
      async getActivityCompletionStatus() {
        await axios.get(`teacher/poll_activity/getPollActivityCompletionStatus/${this.pollActivity.id}`)
          .then(response => {
            this.completionStatus = response.data;
            this.getDonutChart();
            this.renderCharts();
          })
          .catch(error => {
            console.error("Error fetching completion status:", error);
          });
      },
      closeDialog() {
        this.resetData();
        this.$emit('close-dialog');
      }
    }
  };
  </script>